// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PlatformSectionTwo {
  background: rgba(157, 170, 241, 0.3215686275);
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  font-size: 18px;
  padding: 100px 120px;
}
.PlatformSectionTwo .heading {
  font-size: 40px;
  font-weight: 900;
  line-height: 46.88px;
  color: #1c2640;
}
.PlatformSectionTwo .sub-heading {
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 25px;
  letter-spacing: 0em;
  text-align: left;
  color: #1c2640;
  margin-bottom: 60px;
}
.PlatformSectionTwo .PlatformCard {
  width: 85%;
  height: 330px;
  background: #ffffff;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 12px;
  padding: 40px;
  margin-left: 20px;
}
.PlatformSectionTwo .PlatformCard .PlatformCard-title {
  font-family: Roboto;
  font-size: 25px;
  font-style: normal;
  font-weight: 500;
  text-align: left;
  color: #1c2640;
}
.PlatformSectionTwo .PlatformCard .PlatformCard-text {
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #1c2640;
  margin-top: 25px;
  line-height: 1.86;
  text-align: justify;
}
.PlatformSectionTwo .PlatformCardThree,
.PlatformSectionTwo .PlatformCardFour {
  margin-top: 30px;
}
.PlatformSectionTwo .PlatformCardTwo,
.PlatformSectionTwo .PlatformCardFour {
  margin-left: -35px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Platform/SectionTwo/SectionTwo.scss"],"names":[],"mappings":"AAAA;EACC,6CAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AACD;AACC;EACC,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;AACF;AACC;EACC,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AACF;AAEC;EACC,UAAA;EACA,aAAA;EACA,mBAAA;EACA,4CAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;AAAF;AAGE;EACC,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AADH;AAIE;EACC,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAFH;AAME;;EAEC,gBAAA;AAJH;AAOE;;EAEC,6BAAA;AALH","sourcesContent":[".PlatformSectionTwo {\n\tbackground: #9daaf152;\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tposition: relative;\n\tfont-size: 18px;\n\tpadding: 100px 120px;\n\n\t.heading {\n\t\tfont-size: 40px;\n\t\tfont-weight: 900;\n\t\tline-height: 46.88px;\n\t\tcolor: #1c2640;\n\t}\n\t.sub-heading {\n\t\tfont-family: Roboto;\n\t\tfont-size: 18px;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 25px;\n\t\tletter-spacing: 0em;\n\t\ttext-align: left;\n\t\tcolor: #1c2640;\n\t\tmargin-bottom: 60px;\n\t}\n\n\t.PlatformCard {\n\t\twidth: 85%;\n\t\theight: 330px;\n\t\tbackground: #ffffff;\n\t\tbox-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25);\n\t\tborder-radius: 12px;\n\t\tpadding: 40px;\n\t\tmargin-left: 20px;\n\n\n\t\t.PlatformCard-title {\n\t\t\tfont-family: Roboto;\n\t\t\tfont-size: 25px;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 500;\n\t\t\ttext-align: left;\n\t\t\tcolor: #1c2640;\n\t\t}\n\n\t\t.PlatformCard-text {\n\t\t\tfont-size: 14px;\n\t\t\tfont-weight: 400;\n\t\t\ttext-align: left;\n\t\t\tcolor: #1c2640;\n\t\t\tmargin-top: 25px;\n\t\t\tline-height: 1.86;\n\t\t\ttext-align: justify;\n\t\t}\n\t}\n\n\t\t.PlatformCardThree,\n\t\t.PlatformCardFour {\n\t\t\tmargin-top: 30px; \n\t\t}\n\n\t\t.PlatformCardTwo, \n\t\t.PlatformCardFour {\n\t\t\tmargin-left: -35px !important;\n\t\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
